/*
 * OZ 2026-10-16: the info modals of the new product page (snippets/oz-pdp-info-modals.liquid): warranty, battery,
 * screen protector, Price Beat, and the three guarantees under the price (cover, health, returns). Loaded (defer) by that snippet, default product template only.
 *
 * A trigger is any [data-oz-im-open="<name>"] button (the add-on rows' (i), the Price Beat line, the guarantees' (i)); it opens
 * #oz-im-<name>. Desktop (750px and up): a centred card over a dim backdrop; phones: a full-screen sheet (CSS).
 * Open: the modal moves into <body> the first time it opens (so no ancestor's containment can trap position:
 * fixed), the page scroll locks and the Oz Rewards (Smile) launcher hides (html.oz-vm-lock, shared with the video
 * player), focus goes to the close button and stays inside (Tab and Shift+Tab wrap). Close: the X, Escape, a click
 * on the backdrop; focus returns to the trigger.
 * The video card inside plays through assets/oz-pdp-video.js: on desktop its player opens OVER this modal (it sits
 * higher in the stacking order and handles Escape and Tab itself while it is open), on phones a tap plays full
 * screen. Closing this modal pauses any video playing inside it.
 */
(function () {
  'use strict';

  if (window.OzPdpInfo) { return; }

  var open = null;
  var lastFocus = null;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), video[controls], [tabindex]:not([tabindex="-1"])';

  function playerOpen() {
    var vm = document.querySelector('.oz-vm');
    return !!(vm && !vm.hidden);
  }
  function lockScroll(on) {
    var root = document.documentElement;
    if (on) {
      var bar = window.innerWidth - root.clientWidth;
      root.classList.add('oz-vm-lock', 'oz-im-lock');
      if (bar > 0) { document.body.style.paddingRight = bar + 'px'; }
    } else {
      root.classList.remove('oz-im-lock');
      if (!playerOpen()) {
        root.classList.remove('oz-vm-lock');
        document.body.style.paddingRight = '';
      }
    }
  }
  function focusables(m) {
    return Array.prototype.filter.call(m.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0;
    });
  }

  function openModal(name, trigger) {
    var m = document.getElementById('oz-im-' + name);
    if (!m) { return false; }
    if (open && open !== m) { closeModal(true); }
    if (m.parentNode !== document.body) { document.body.appendChild(m); }
    lastFocus = trigger || document.activeElement;
    open = m;
    lockScroll(true);
    m.hidden = false;
    var body = m.querySelector('.oz-im__body');
    if (body) { body.scrollTop = 0; }
    // the next frame, so the opening transition runs from the closed state
    requestAnimationFrame(function () { requestAnimationFrame(function () { if (open === m) { m.classList.add('is-open'); } }); });
    if (trigger) { trigger.setAttribute('aria-expanded', 'true'); }
    var close = m.querySelector('[data-oz-im-close]');
    if (close) { close.focus({ preventScroll: true }); }
    return true;
  }

  function closeModal(silent) {
    if (!open) { return; }
    var m = open;
    open = null;
    Array.prototype.forEach.call(m.querySelectorAll('video'), function (v) { try { v.pause(); } catch (err) {} });
    m.classList.remove('is-open');
    m.hidden = true;
    lockScroll(false);
    if (lastFocus) {
      if (lastFocus.hasAttribute && lastFocus.hasAttribute('aria-expanded')) { lastFocus.setAttribute('aria-expanded', 'false'); }
      if (!silent) { lastFocus.focus({ preventScroll: true }); }
    }
    lastFocus = null;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }
    var trig = t.closest('[data-oz-im-open]');
    if (trig) {
      // the add-on rows' (i) sits inside the switch's label: never toggle the switch
      e.preventDefault();
      e.stopPropagation();
      openModal(trig.getAttribute('data-oz-im-open'), trig);
      return;
    }
    if (!open) { return; }
    if (t.closest('[data-oz-im-close]') && open.contains(t)) { e.preventDefault(); closeModal(); return; }
    if (t === open) { closeModal(); }
  });

  // window, bubbling: the video player's own key handler (document, capture) stops Escape and Tab first while it is open
  window.addEventListener('keydown', function (e) {
    if (!open || playerOpen()) { return; }
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); closeModal(); return; }
    if (e.key !== 'Tab') { return; }
    var f = focusables(open);
    if (!f.length) { e.preventDefault(); return; }
    var first = f[0];
    var last = f[f.length - 1];
    var at = f.indexOf(document.activeElement);
    if (e.shiftKey && (at <= 0)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (at === -1 || at === f.length - 1)) { e.preventDefault(); first.focus(); }
  });

  // back from the browser's memory (bfcache) with a modal open: put the page back as it was
  window.addEventListener('pageshow', function (e) { if (e.persisted && open) { closeModal(true); } });

  window.OzPdpInfo = { open: openModal, close: function () { closeModal(); } };
})();
